import Vue from 'vue'
import App from './App.vue'

// Apollo
import { createProvider } from './vue-apollo'

// Router
import home from "./components/latestShows.vue"
import shows from "./components/shows.vue"
import showDetail from "./components/showDetail.vue"
import about from "./components/about.vue"
import contact from "./components/contact.vue"
import search from "./components/search.vue"

import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routes = [
  { path: '/', component: home },
  { path: '/shows', component: shows },
  { path: '/search', component: search },
  { path: '/show/:showId', name: 'show', component: showDetail },
  { path: '/about', component: about },
  { path: '/contact', component: contact }

]

const router = new VueRouter({
  routes: routes
})

// bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

// tippy
import tippy from 'tippy.js'
tippy('[title]');

// vue meta
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.config.productionTip = false

// var mixcloudApi;
// Vue.mixin({
//   methods: {
//     playThisShow: function (show) {
//       // grab mixcloud api
//       var Mixcloud = window.Mixcloud;
//       // parse link
//       let link = show.url_mixcloud.replace("https://www.mixcloud.com", "");

//       if (!mixcloudApi) {
//         mixcloudApi = Mixcloud.FooterWidget(link, {
//           hide_artwork: true,
//         });
//         mixcloudApi.then(function(widget){
//           widget.play();
//         });
//       } else {

//         mixcloudApi.then(function (widget) {
//           widget.load(link, true);
//         });
//       }
//     }
//   }
// });

new Vue({
  router,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
